import React from "react";
import { connect } from "react-redux";

import ProductService from "services/product";

import ZeeTable from "components/ZeeTable";

import { update, create, remove } from "reducers/product";
import { setBreadcrumbs } from "reducers/view";

class Product extends React.Component {
  productService = new ProductService();

  columns = {
    name: { name: "Name" },
    sku: { name: "SKU" },
    price: { name: "Price" },
  };

  constructor() {
    super(...arguments);
    this.props.setBreadcrumbs([{ name: "Products", slug: "/products" }]);
  }

  get data() {
    return this.props.product;
  }

  async onDelete(product) {
    const result = await this.productService
      .delete(product)
      .then(({ data }) => data);
    if (result.success) {
      this.props.remove(result.data);
      return result.data;
    }
    return false;
  }

  async onEdit(product) {
    const result = await this.productService
      .update(product)
      .then(({ data }) => data);
    if (result.success) {
      this.props.update(result.data);
      return result.data;
    }
    return false;
  }

  async onAdd(product) {
    const result = await this.productService
      .create(product)
      .then(({ data }) => data);
    if (result.success) {
      this.props.create(result.data);
      return result.data;
    }
    return false;
  }

  onRowDoubleClick(product) {
    const { history } = this.props;
    history.push(`products/${product.id}`);
  }

  render() {
    return (
      <ZeeTable
        title="Product"
        columns={this.columns}
        data={this.data}
        hasPagination={true}
        hasSort={true}
        hasDelete={true}
        hasEdit={true}
        hasAdd={true}
        hasSearch={true}
        orderBy="name"
        onEdit={(product) => this.onEdit(product)}
        onDelete={(product) => this.onDelete(product)}
        onAdd={(product) => this.onAdd(product)}
        onRowDoubleClick={(product) => this.onRowDoubleClick(product)}
      />
    );
  }
}

export default connect(
  (state) => {
    return {
      product: state.product.all,
    };
  },
  { update, create, remove, setBreadcrumbs }
)(Product);
